import DashboardTitleComponent from "../../custom/DashboardTitleComponent";
import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Menu, MenuItem
} from "@mui/material";
import CustomAutocompleteField from "../../custom/CustomAutoCompleteField";
import CustomIconButton from "../../custom/CustomIconButton";
import CustomTextField from "../../custom/CustomTextField";
import CustomButton from "../../custom/CustomButton";
import { isBlank } from "../../../utils/ValidationRules";
import escapeHtml from "lodash/escape";
import { useUser } from "../../../pages/UserContext";
import { numberToRupiah } from "../../../utils/format";
import { formatDateTimestamp } from "../../../utils/date";
import Swal from "../../../utils/swal";
import { showSuccessToast, showErrorToast } from "../../../utils/swalToast";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import apiClient from "../../../utils/apiClient";
import CustomDataGrid from "../../custom/CustomDataGrid";

const AjuanPembayaranMenu = () => {
  const userDetails = useUser();

  // Form state
  const [listPembayaran, setListPembayaran] = useState("");
  const [jenisIuran, setJenisIuran] = useState("");
  const [vaCode, setVaCode] = useState("");
  const [membershipUpdate, setMembershipUpdate] = useState("");
  const [biaya, setBiaya] = useState("");
  const [listPembayaranItems, setListPembayaranItems] = useState([]);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [previewImage, setPreviewImage] = useState(null);

  const [open, setOpen] = useState(false);
  const [openAddMaster, setAddOpenMaster] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiClient.get("/master-pembayaran-iuran");
        setListPembayaranItems(
          response.data.data.map((item) => ({
            uuid: item.uuid,
            name: item.name,
            biaya: item.biaya,
            va_code: item.va_code ?? "-"
          }))
        );
      } catch (error) {
        console.log("error", error)
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let url = "/pembayaran-iuran";
        if (userDetails.role !== "admin") {
          url += `?userId=${userDetails.uuid}`;
        }
        const response = await apiClient.get(url);

        const statusMapping = {
          pending: "Perlu Diproses",
          approved: "Diterima ✅",
          rejected: "Ditolak ❌",
        };

        setRows(
          response.data.data.map((iuranPembayaran, index) => ({
            no: index + 1 + (page - 1) * 10,
            id: iuranPembayaran.id,
            requestId: iuranPembayaran.request_id,
            jenisIuran: iuranPembayaran.nama_iuran,
            biaya: numberToRupiah(iuranPembayaran.biaya),
            vaCode: getVaCodeFromJenisIuranId(iuranPembayaran.jenis_pembayaran_iuran_id),
            keterangan: iuranPembayaran.keterangan,
            buktiFoto: iuranPembayaran.bukti_foto,
            namaLengkap:
              iuranPembayaran.gelar_depan +
              " " +
              iuranPembayaran.nama_lengkap +
              " " +
              iuranPembayaran.gelar_belakang,
            requestedAt: formatDateTimestamp(iuranPembayaran.requested_at),
            status:
              statusMapping[iuranPembayaran.status] || iuranPembayaran.status,
            statusRaw: iuranPembayaran.status,
          }))
        );
      } catch (error) {
        console.error("Error fetching instruct", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [page, refresh, userDetails.role, userDetails.uuid, listPembayaranItems]);

  const handleFetchPembayaran = async () => {
    try {
      const response = await apiClient.get("/master-pembayaran-iuran");
      setListPembayaranItems(
        response.data.data.map((item) => ({
          uuid: item.uuid,
          name: item.name,
          biaya: item.biaya,
          va_code: item.va_code
        }))
      );
    } catch (error) {
      console.log("error fetching : ", error)
    }
  };

  const getVaCodeFromJenisIuranId = (jenisIuranId) => {
    for (let pembayaranItem of listPembayaranItems) {
      if (pembayaranItem.uuid === jenisIuranId) {
        return pembayaranItem.va_code;
      }
    }
    return "-";
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleOpenMasterModal = () => {
    setAddOpenMaster(true);
  };

  const handleCloseMasterModal = () => {
    setAddOpenMaster(false);
  };

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setListPembayaran("");
    setSelectedFile(null);
    setPreviewImage(null);
  };

  const handleShowBuktiFotoPembayaran = (buktiFoto) => {
    const buktiFotoURL = `${process.env.REACT_APP_BACKEND_HOST}${buktiFoto}`;
    Swal.fire({
      imageUrl: buktiFotoURL,
      imageAlt: "Bukti pembayaran",
      showConfirmButton: false,
    });
  };

  const handleAddMasterIuran = async () => {
    if (!jenisIuran) {
      return showErrorToast("Harap isi jenis iuran yang ingin dibuat");
    }

    if (!biaya) {
      return showErrorToast("Harap isi biaya iuran yang ingin dibuat");
    }

    if (!vaCode) {
      return showErrorToast("Harap isi kode VA yang ingin dibuat");
    }
  
    const requestData = {
      jenisIuran: jenisIuran,
      biaya: biaya,
      vaCode: vaCode,
    };
  
    try {
      setLoading(true);

      await apiClient.post("/master-pembayaran-iuran", requestData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      showSuccessToast("Penambahan master iuran berhasil dibuat");
      setMembershipUpdate(false);
      setJenisIuran(null);
      setBiaya(null);
      setVaCode(null);
      setAddOpenMaster(false);
      setRefresh((prev) => !prev);
    } catch (error) {
      showErrorToast("Terjadi kesalahan saat mengajukan pembayaran.");
    } finally {
      setLoading(false);
    }
  }

  const handleRequestPembayaranIuran = async () => {
    if (!listPembayaran) {
      return showErrorToast("Pilih jenis pembayaran terlebih dahulu!");
    }

    if (!selectedFile) {
      return showErrorToast("Harap upload bukti pembayaran!");
    }

    const formData = new FormData();
    formData.append("jenis_iuran", listPembayaran);
    formData.append("bukti_pembayaran", selectedFile);

    try {
      setLoading(true);
      Swal.fire({
        title: "Mohon Tunggu...",
        text: "Sedang memproses pembayaran",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await apiClient.post("/pembayaran-iuran/request", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      showSuccessToast("Request Pembayaran Berhasil Diajukan");

      setListPembayaran(null);
      setSelectedFile(null);
      setOpen(false);
      setRefresh((prev) => !prev);
    } catch (error) {
      showErrorToast("Terjadi kesalahan saat mengajukan pembayaran.");
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id, nama, jenisIuran) => {
    const result = await Swal.fire({
      title: "Konfirmasi Persetujuan",
      html: `Apakah Anda yakin ingin menyetujui pembayaran iuran
        <span style="color: red;">[${escapeHtml(nama)}]</span> untuk jenis iuran <br>
        <span style="color: red;">[${escapeHtml(jenisIuran)}]</span>
        ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#003158",
      cancelButtonColor: "#A92027",
      confirmButtonText: "Terima",
      cancelButtonText: "Batal",
    });

    if (result.isConfirmed) {
      try {
        const response = await apiClient.put("/pembayaran-iuran/request/decision", {
          requestId: id,
          status: "approved",
          keterangan: "Disetujui Admin",
        });
        if (response.status === 201) {
          showSuccessToast(response.data.msg);
          setRefresh((prev) => !prev);
        } else {
          showErrorToast(response.data.msg);
        }
      } catch (error) {
        showErrorToast("Kesalahan saat menyetujui pembayaran.");
      }
    }
  };

  const handleReject = async (id, nama, jenisIuran) => {
    const { value: keterangan } = await Swal.fire({
      title: "Konfirmasi Penolakan",
      html: `Anda akan melakukan penolakan pembayaran <br>
      <span style="color: red;">[${escapeHtml(nama)}]</span> untuk jenis iuran
       <span style="color: red;">[${escapeHtml(jenisIuran)}]</span>.<br><br>Tolong masukkan alasan penolakan pembayaran ini:`,
      input: "text",
      inputPlaceholder: "Contoh: Bukti pembayaran tidak valid",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#003158",
      cancelButtonColor: "#A92027",
      confirmButtonText: "Tolak",
      cancelButtonText: "Batal",
      inputValidator: (value) => {
        if (!value) {
          return "Anda harus mengisi alasan penolakan!";
        }
      },
    });

    if (keterangan) {
      try {
        const response = await apiClient.put("/pembayaran-iuran/request/decision", {
          requestId: id,
          status: "rejected",
          keterangan: keterangan,
        });

        if (response.status === 201) {
          showSuccessToast(response.data.msg);
          setRefresh((prev) => !prev);
        } else {
          showErrorToast(response.data.msg);
        }
      } catch (error) {
        showErrorToast("Kesalahan saat menolak pembayaran.");
      }
    }
  };

  const AdminActionsDropdown = ({ params }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
  
    const handleMenuOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleMenuClose = () => {
      setAnchorEl(null);
    };
  
    const isApproved = params.row.statusRaw === "approved";
    const isRejected = params.row.statusRaw === "rejected";
  
    return (
      <>
        <Button
          aria-controls="admin-menu"
          aria-haspopup="true"
          onClick={handleMenuOpen}
        >
          <MoreVertIcon />
        </Button>
        <Menu
          id="admin-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
        >
          {!isApproved && (
            <MenuItem
              onClick={() => {
                handleApprove(params.row.requestId, params.row.namaLengkap, params.row.jenisIuran);
                handleMenuClose();
              }}
            >
              Approved Pembayaran
            </MenuItem>
          )}
  
          {!isRejected && (
            <MenuItem
              onClick={() => {
                handleReject(params.row.requestId, params.row.namaLengkap, params.row.jenisIuran);
                handleMenuClose();
              }}
            >
              Tolak Pembayaran
            </MenuItem>
          )}
  
          <MenuItem
            onClick={() => {
              handleShowBuktiFotoPembayaran(params.row.buktiFoto);
              handleMenuClose();
            }}
          >
            Lihat Bukti Pembayaran
          </MenuItem>
        </Menu>
      </>
    );
  };

  const columns = [
    { field: "no", headerName: "No.", flex: 1 },
    { field: "jenisIuran", headerName: "Jenis Iuran", flex: 1 },
    { field: "biaya", headerName: "Biaya", flex: 1, minWidth: 160 },
    { field: "vaCode", headerName: "Kode VA", flex: 1 },
    { field: "status", headerName: "Status", flex: 1 },
    { field: "keterangan", headerName: "Keterangan Admin", flex: 1 },
    { field: "requestedAt", headerName: "Tanggal Transaksi", flex: 1 },
    {
      field: "buktiFoto",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          {userDetails.role === "admin" ? (
            <AdminActionsDropdown params={params} />
          ) : (
            <CustomIconButton
              baseColor="#003158"
              hoverColor="#00213A"
              tooltipText="Lihat Bukti Pembayaran"
              icon={<VisibilityIcon sx={{ color: "WHITE" }} />}
              onClick={() => handleShowBuktiFotoPembayaran(params.row.buktiFoto)}
            />
          )}
        </div>
      ),
    },
  ];

  if (userDetails.role === "admin") {
    columns.splice(1, 0, {
      field: "namaLengkap",
      headerName: "Nama",
      flex: 1,
    });
  }

  return (
    <div>
      <DashboardTitleComponent text={"Pengajuan Pembayaran"} />
      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
        <CustomButton
          onClick={handleOpenModal}
          text="Request Pembayaran Iuran"
          isFullWidth={false}
          baseColor="#003158"
          hoverColor="#00213A"
        />
      </div>
      <div style={{ height: "10px" }}></div>
      <CustomDataGrid
        rows={rows}
        loading={loading}
        columns={columns}
        setPage={setPage}
      />
      <Dialog open={open} onClose={handleCloseModal} fullWidth maxWidth="sm">
        <DialogTitle>Request Pembayaran Iuran</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography>Jenis Pembayaran</Typography>
              <CustomAutocompleteField
                onFocus={handleFetchPembayaran}
                value={listPembayaran}
                rule={(value) => isBlank(value, "Jenis Pembayaran Iuran")}
                options={listPembayaranItems}
                onChange={(newValue) => {
                  setListPembayaran(newValue ? newValue.uuid : "");
                  setSelectedFile(null);
                  setPreviewImage(null);
                }}
                placeholder="Pilih Jenis Pembayaran Iuran"
                searchBy="uuid"
                withCost={true}
              />
            </Grid>
            {listPembayaran && (
              <>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    color="error"
                    sx={{ fontWeight: "bold" }}
                  >
                    * Mohon upload bukti pembayaran sesuai dengan biaya yang
                    tertera pada jenis pembayaran
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Upload Bukti Pembayaran
                  </Typography>
                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={handleFileChange}
                    style={{
                      display: "block",
                      marginTop: "8px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "100%",
                      maxWidth: "300px",
                    }}
                  />
                  {previewImage && (
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src={previewImage}
                        alt="Bukti Pembayaran"
                        style={{
                          width: "100%",
                          maxWidth: "300px",
                          borderRadius: "5px",
                          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                        }}
                      />
                    </div>
                  )}
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <CustomButton
            onClick={handleCloseModal}
            text="Cancel"
            isFullWidth={false}
            baseColor="#A92027"
            hoverColor="#8C1016"
          />
          <CustomButton
            onClick={handleRequestPembayaranIuran}
            text="Submit"
            isFullWidth={false}
            baseColor="#003158"
            hoverColor="#00213A"
          />
        </DialogActions>
      </Dialog>

      {userDetails.role === "admin" && (
        <Dialog
          open={openAddMaster}
          onClose={handleCloseMasterModal}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>Penambahan Master Iuran</DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item md={4} xs={12}>
                <Typography>
                  Jenis Iuran<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomTextField
                  value={jenisIuran}
                  onChange={(event) => setJenisIuran(event.target.value)}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <Typography>
                  Biaya<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomTextField
                  value={biaya}
                  onChange={(event) => setBiaya(event.target.value)}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <Typography>
                  Kode VA<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomTextField
                  value={vaCode}
                  onChange={(event) => setVaCode(event.target.value)}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <CustomButton
              onClick={handleCloseMasterModal}
              text="Cancel"
              isFullWidth={false}
              baseColor="#A92027"
              hoverColor="#8C1016"
            />
            <CustomButton
              onClick={handleAddMasterIuran}
              text="Submit"
              isFullWidth={false}
              baseColor="#003158"
              hoverColor="#00213A"
            />
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default AjuanPembayaranMenu;
